import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren } from 'react'
import { sanitize } from './sanitize'

const { VITE_POSTHOG_KEY, MODE } = import.meta.env

if (VITE_POSTHOG_KEY) {
  posthog.init(VITE_POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com',
    debug: MODE === 'development',
    disable_session_recording: true,
    disable_persistence: true,
    persistence: 'memory',
    before_send: function (event) {
      if (!event) {
        return null
      }
      sanitize(event.properties)
      return event
    },
  })
}

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
